import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";
import { PROTECTED_ROUTE_OPTIONS } from "../../-common";

import { Protected } from "~/entities/auth";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/admin-panel/dashboard")({
  head: defineHead({
    titleT: Tk.DASHBOARD,
  }),
  component: Protected(PROTECTED_ROUTE_OPTIONS.ADMIN_PANEL_DASHBOARD),
});
